<template>
  <div class="positionDetails clearfix">
    <div class="banner" style="background-image: url(/img/pbeijing.png)">
      <div class="title">
        <p class="p1">职位名称：{{ form.positionName }}</p>
        <p class="p2">招录人数：{{ form.numbers }}</p>
        <p class="p2">报考人数：{{ form.extSignUpCount == 0 ? '-' : form.extSignUpCount }}</p>
      </div>
      <div class="main">
        <p class="p1">单位信息</p>
        <p class="p2">
          <span class="span1">地区：</span><span>{{ form.extArea }}</span>
        </p>
        <p class="p2">
          <span class="span1">招录机关：</span><span>{{ form.organs }}</span>
        </p>
        <p class="p2">
          <span class="span1">用人单位：</span><span>{{ form.units }}</span>
        </p>
        <p class="p1">职位信息</p>
        <p class="p2">
          <span class="span1">职位名称：</span
          ><span>{{ form.positionName }}</span>
        </p>
        <p class="p2">
          <span class="span1">职位代码：</span
          ><span>{{ form.positionCode }}</span>
        </p>
        <p class="p2">
          <span class="span1">职位简介：</span
          ><span>{{ form.positionDesc }}</span>
        </p>
        <p class="p2">
          <span class="span1">招录人数：</span><span>{{ form.numbers }}</span>
        </p>
        <p class="p2">
          <span class="span1">考试类别：</span
          ><span>{{ form.positionType }}</span>
        </p>
        <p class="p2">
          <span class="span1">报考人数：</span
          ><span v-if="form.extSignUpCount == 0">-</span><span v-else>{{ form.extSignUpCount }}</span>
        </p>
        <p class="p2">
          <span class="span1">竞争比：</span><span v-if="form.competition == 0"></span><span v-else>{{ form.competition }}</span>
        </p>
        <p class="p2">
          <span class="span1">进面分数线：</span
          ><span>{{ form.extMinPaperScore }}</span>
        </p>
        <p class="p2">
          <span class="span1">最高分数线：</span
          ><span>{{ form.extMaxPaperScore }}</span>
        </p>
        <p class="p2">
          <span class="span1">面试人数：</span
          ><span>{{ form.extInterviewCount }}</span>
          <van-button plain size="mini" round style="float: right" type="info" @click="handleInterview(form.positionCode)">查看面试名单</van-button>
        </p>
        <p class="p1">报考条件</p>
        <p class="p2">
          <span class="span1">招考对象：</span><span>{{ form.target }}</span>
        </p>
        <p class="p2">
          <span class="span1">专业（本 科）：</span
          ><span>{{ form.underGraduate }}</span>
        </p>
        <p class="p2">
          <span class="span1">专业（研究生）：</span
          ><span>{{ form.graduate }}</span>
        </p>
        <p class="p2">
          <span class="span1">学历：</span><span>{{ form.education }}</span>
        </p>
        <p class="p2">
          <span class="span1">学位：</span><span>{{ form.degree }}</span>
        </p>
        <p class="p2">
          <span class="span1">政治面貌：</span><span>{{ form.political }}</span>
        </p>
        <p class="p2">
          <span class="span1">专业类别：</span
          ><span>{{ form.specialtyExam }}</span>
        </p>
        <p class="p2">
          <span class="span1">其他条件：</span><span>{{ form.others }}</span>
        </p>
        <p class="p2">
          <span class="span1">备注：</span><span>{{ form.remarks }}</span>
        </p>
      </div>
    </div>
    <div class="hint">
      <p>
        华智公考提示广大考生，请报考前仔细阅读对应职位招录要求或
        联系招录单位确认，本职位检索系统提供内容仅供参考！
      </p>
    </div>
  </div>
</template>

<script>
import { api_position } from "@/common/Request.js";
import { divide } from "@/utils/number.js";
export default {
  data() {
    return {
      form: {},
    };
  },
  created() {
    this.positionList();
  },
  methods: {
    positionList() {
      api_position.positionDetails({
        code: this.$route.query.code,
        zyear: this.$route.query.zyear
      }).then((res) => {
        this.form = res.data[0];
        this.form.competition = divide(
          this.form.extSignUpCount,
          this.form.extInterviewCount
        );
      });
    },
    handleInterview(positionCode) {
      this.$router.push({ name: 'interviewlist',query: { positionCode: positionCode, zyear: this.$route.query.zyear}})
    }
  },
};
</script>

<style lang="scss" scoped>
p {
  margin: 0;
}
.positionDetails {
  .banner {
    //width: 23.4375rem /* 750/32 */;
    background-size: 100% 9.6875rem /* 310/32 */;
    background-repeat: no-repeat;
    padding-top: 1.5625rem /* 50/32 */;
    position: relative;
    .title {
      margin-left: 1.5625rem /* 50/32 */;
      margin-bottom: .625rem /* 20/32 */;
      .p1 {
        font-size: 1rem /* 32/32 */;
        color: #fff;
        font-weight: bold;
      }
      .p2 {
        font-size: .8125rem /* 26/32 */;
        font-weight: 500;
        color: #fff;
        margin-top: .625rem /* 20/32 */;
      }
    }
    .main {
      //width: 21.5625rem /* 690/32 */;
      background-color: #fff;
      margin-left: .9375rem /* 30/32 */;
	  margin-right: .9375rem /* 30/32 */;
      padding: .9375rem /* 30/32 */ .625rem /* 20/32 */;
      box-sizing: border-box;
      box-shadow: 0px 1px 10px 0px rgba(0, 0, 0, 0.06);
      border-radius: .375rem /* 12/32 */;
      margin-bottom: .9375rem /* 30/32 */;
      .p1 {
        font-size: .9375rem /* 30/32 */;
        font-weight: bold;
      }
      .p1:nth-child(n + 2) {
        margin-top: .9375rem /* 30/32 */;
      }
      .p2 {
        font-size: .8125rem /* 26/32 */;
        margin-top: .625rem /* 20/32 */;
        .span1 {
          color: #888;
        }
      }
    }
  }
  .hint {
    padding: .9375rem /* 30/32 */ .9375rem /* 30/32 */;
    font-size: .75rem /* 24/32 */;
    color: #ff3229;
    font-weight: 500;
  }
}
</style>
